import React, { createContext, useContext, useMemo, useState } from "react";
import { useAuth } from "@/context/AuthContext.jsx";

const KEY = "orignal2026.marcel.mode";
const MarcelModeContext = createContext(null);

export function readMarcelMode() {
  try {
    return localStorage.getItem(KEY) === "admin" ? "admin" : "hunter";
  } catch {
    return "hunter";
  }
}

export function MarcelModeProvider({ children }) {
  const [mode, setModeState] = useState(readMarcelMode);
  const value = useMemo(() => ({
    mode,
    setMode: (next) => {
      const choice = next === "admin" ? "admin" : "hunter";
      try { localStorage.setItem(KEY, choice); } catch { /* private mode */ }
      setModeState(choice);
    },
  }), [mode]);
  return <MarcelModeContext.Provider value={value}>{children}</MarcelModeContext.Provider>;
}

export function useMarcelMode() {
  const { username, role } = useAuth();
  const ctx = useContext(MarcelModeContext);
  const isMarcel = username === "marcel";
  const mode = isMarcel ? (ctx?.mode || "hunter") : "hunter";
  const actingAsAdmin = role === "admin" && (!isMarcel || mode === "admin");
  return {
    isMarcel,
    mode,
    setMode: ctx?.setMode || (() => {}),
    actingAsAdmin,
  };
}
